import StaffEditDialog from './StaffEditDialog.view';

export default StaffEditDialog;
